module.exports = __webpack_public_path__ + "static/media/belgeler.1c1ec974.jpg";